export default __webpack_public_path__ + "a7c6b17572144a6728189fd8e45f5ec3.svg";